<template>
  <div class="recent-keyword-empty-taglist">
    <div class="attention-mark-area">
      <div class="icon">
        <EmptyIcon />
      </div>
    </div>
    <div class="info-text">
      <span class="dark-purple">'{{getClampText(searchKeyword, 30)}}'</span> 검색결과가 없어요.<br/>
      <span v-if="changeKeyword === ''">
            이런 검색어는 어떠세요?
          </span>
      <span v-else>
            혹시 "{{changeKeyword}}" 찾으시나요?
          </span>
    </div>
    <a class="btn-research" v-if="changeKeyword !== ''" @click.prevent="reSearchByFixedKeywordFn">
      <span>'{{changeKeyword}}' 재검색</span>
      <CircleArrowBlueIcon />
    </a>
    <div class="recommend-keyword-list">
          <span v-for="(keywordItem) in keywordList"
                :key="'empty-keyword' + keywordItem.text"
                @click.prevent="()=>moveToRecommendTagFn(keywordItem)"
                class="tag-item">
            {{keywordItem.text}}
          </span>
    </div>
    <!--
        [new] 검색 결과 없거나 잘못 입력한 경우 추가

        <div class="search-result-top-txt">
        <span>‘<strong>무한도전</strong>’ 으로 검색했어요.</span>
        <a href="#">‘angksehwjs’ 검색결과 보기<NextButtonGrey /></a>
        </div>
     -->
  </div>
</template>
<script>
import EmptyIcon from '@/assets/svg/common/img_empty.svg'
import CircleArrowBlueIcon from '@/assets/svg/common/ic-research-blue.svg'
import { getClampText } from '@/common/util/text.utils'
export default {
  name: 'SearchRecommendTagList',
  components: {
    EmptyIcon,
    CircleArrowBlueIcon
  },
  props: {
    searchKeyword: {
      type: String
    },
    changeKeyword: {
      type: String
    },
    keywordList: {
      type: Array
    },
    reSearchByFixedKeywordFn: {
      type: Function
    },
    moveToRecommendTagFn: {
      type: Function
    }
  },
  methods: {
    getClampText: getClampText,
  }
}
</script>
<style scoped>
  .recent-keyword-empty-taglist{
    display: flex;
    flex-direction: column;
    align-items: center;
    height: calc(100vh - 77px);
    padding-top: 52px
  }
  .attention-mark-area .icon {
    position: relative;
    width: 50px;
    height: 50px;
    margin: 0 auto;
  }
  .info-text {
    margin-top: 16px;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #a5a5a5;
  }
  .recommend-keyword-list {
    position: relative;
    width: 100%;
    margin-top: 30px;
    text-align: center;
  }
  .tag-item{
    z-index: 100;
    display: inline-block;
    position: relative;
    min-width: 61px;
    margin: 10px 10px 0 0;
    padding: 5px 10px;
    text-align: center;
    font-size: 14px;
    line-height: 18px;
    color: #a5a5a5;
    border: 1px solid #b4b4b4;
    -moz-border-radius: 16px 16px 16px 16px;
    border-radius: 16px 16px 16px 16px;
  }
  .btn-research {
    display: block;
    margin-top: 40px;
    font-size: 12px;
    line-height: 18px;
    color: #a5a5a5;
    text-align: center;
  }
  .btn-research span,
  .btn-research svg{
    vertical-align: middle;
  }
  .btn-research > svg{
    width: 18px;
    line-height: 18px;
  }
  .btn-research span + svg{
    margin-left: 4px;
  }

  /* 검색 결과 > 카테고리 */
  .cell-category li{
    width: 160px;
    height: 80px;
    background-color: #252525;
  }
  .cell-category a{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 80px;
  }
  .cell-category a > span + strong{
    margin-top: 2px;
  }
  .cell-category a > span{
    font-size: 12px;
    line-height: 14px;
    color: #a5a5a5;
  }
  .cell-category a > strong{
    font-size: 14px;
    line-height: 20px;
    color: #fff;
  }
</style>
